import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next-translate-routes-multi-domain';
export function ProductPaymentTerms({
  disableTitle,
}: {
  disableTitle?: boolean;
}) {
  const { t } = useTranslation('products');

  const { locale } = useRouter();

  const showRenting = locale === 'es-ES';
  return (
    <div className='px-8'>
      {!disableTitle && <p className='h2 my-8'>{t('DETAIL_PAYMENT_HEADER')}</p>}
      <ul className='flex flex-col justify-between space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0'>
        <li
          className={
            'flex flex-1 flex-col items-center justify-center border-[1px] px-4 py-4 text-center'
          }
        >
          <div className='inner-wrapper'>
            <div className={`icons icon-icons-06`}>
              <svg viewBox='0 0 16 16' className={`icons icon-icons-06`}>
                <use xlinkHref={`#icon-icons-06`} />
              </svg>
            </div>
            <p
              dangerouslySetInnerHTML={{ __html: t('DETAIL_PAYMENT_TERMS1') }}
              className='h3 uppercase'
            />
          </div>
        </li>
        <li
          className={
            'flex flex-1 flex-col items-center justify-center border-[1px] px-4 py-4 text-center'
          }
        >
          <div className='inner-wrapper'>
            <div className={`icons icon-icons-32`} />
            <p
              dangerouslySetInnerHTML={{ __html: t('ASSET_FINANCING') }}
              className='h3 uppercase'
            />
          </div>
        </li>
        {showRenting && (
          <li
            className={
              'flex flex-1 flex-col items-center justify-center border-[1px] px-4 py-4 text-center'
            }
          >
            <div className='inner-wrapper'>
              <div className={`icons icon-icons-22`}>
                <svg viewBox='0 0 16 16' className={`icons icon-icons-22`}>
                  <use xlinkHref={`#icon-icons-22`} />
                </svg>
              </div>
              <h3
                dangerouslySetInnerHTML={{ __html: t('DETAIL_PAYMENT_TERMS4') }}
                className='uppercase'
              />
            </div>
          </li>
        )}
      </ul>
    </div>
  );
}
